import { Core } from "Components/core";

export class FormField extends Core {
  constructor(domElem) {
    super(domElem, FormField.className);
  }

  _buildMessage() {
    const message = document.createElement("div");
    message.classList.add(
      `${FormField.className}${FormField.ELEM_DELIM}message`
    );
    this.domElem.append(message);
    return (this._message = message);
  }

  // сообщение при ошибке
  _getMessage() {
    return this._message || this._buildMessage();
  }

  // вывод сообщения при ошибке
  setValidationMessage(message) {
    this._getMessage().textContent = message;
    return this;
  }

  getControl() {
    return this._control || (this._control = this.getElemNode("control"));
  }

  getVal() {
    return this.getControl().value;
  }

  getName() {
    return this.domElem.getAttribute("data-name");
  }

  static className = "form-field";
  static instances = {};

  static init() {
    document.querySelectorAll(`.${FormField.className}`).forEach((el) => {
      return new FormField(el);
    });
  }
}
